import { GameObjects } from "phaser";

export default class HealthBar {
    constructor(scene, x, y) {

        this.bar = new GameObjects.Graphics(scene);
        
        this.x = x;
        this.y = y;
        this.value = 100;
        this.p = 66 / 100;

        this.draw();
        scene.add.existing(this.bar);

            
    }

    setVisible(visible) {
        this.bar.setVisible(visible);
    }

    restartBar() {
        this.value = 100;
        this.draw();
    }

    decrease (amount)
    {
        this.value -= amount;

        if (this.value < 0)
        {
            this.value = 0;
        }

        this.draw();

        return (this.value === 0);
    }

    draw ()
    {
        this.bar.clear();

        //  BG
        this.bar.fillStyle(0x181425);
        this.bar.fillRect(this.x, this.y, 70, 12);

        //  Health

        this.bar.fillStyle(0x000000);
        this.bar.fillRect(this.x + 2, this.y + 2, 66, 9);

        if (this.value < 30)
        {
            this.bar.fillStyle(0x505874);
        }
        else
        {
            this.bar.fillStyle(0x505874);
        }

        var d = Math.floor(this.p * this.value);

        this.bar.fillRect(this.x + 2, this.y + 2, d, 9);
    }

    updatePosition(x, y) {
        this.bar.setPosition(x, y);
    }
    
    // setScale(scale) {
    //     this.bar.setScale(scale);
    // }

    setScrollFactor(scroll) {
        this.bar.setScrollFactor(scroll);
    }

    setOpacity(opacity){
        this.bar.setAlpha(opacity);
    }

}